<div style="margin-top: 10pt; text-align: center">
    <img src="assets/images/system_splash.png" />
</div>